import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { restaurantSlug, productSlug, lineItemId } = useLocalSearchParams<{
    restaurantSlug: string;
    productSlug: string;
    lineItemId: string;
  }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Edit Customization — {restaurantSlug}/{productSlug}/{lineItemId}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton
        href={`/(modals)/${restaurantSlug}/${productSlug}` as never}
        dismiss
      />
    </ExpoRouterDemoScreen>
  );
}
